module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-107.4fd9bf05.svg";